import { Directive, Input } from '@angular/core';
import { Behavior } from './types-and-interfaces';

@Directive({
  selector: '[crmDropdownHeader], crm-dropdown-header',
  standalone: true,
})
export class DropdownHeaderDirective {
  behavior?: Behavior;

  @Input({ required: true }) set onState(value: Behavior) {
    this.behavior = value;
  }
}
